import { AccidentReport, SearchAccidentReportsCondition } from "@/models/accidentReport";
import { httpClient } from "./API";
import { AxiosResponse } from "axios";
import { RecordCount } from "@/models/common";
import qs from "qs";

/**
 * 指定された条件で事故報告を取得する
 * @param condition 検索条件
 * @param page ページ番号
 * @param size ページサイズ
 * @returns 事故報告のリスト
 */
export const getAccidentReportsAPI = async (
  condition: SearchAccidentReportsCondition,
  page: number,
  size: number
): Promise<AxiosResponse<AccidentReport[]>> => {
  return httpClient.get("core/internal/calgary/accidentReports/", {
    params: { ...condition, page, size },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

/**
 * 事故報告の総数を取得する
 * @param condition 検索条件
 * @returns 事故報告の件数
 */
export const countAccidentReportsAPI = async (
  condition: SearchAccidentReportsCondition
): Promise<AxiosResponse<RecordCount>> => {
  return httpClient.get("core/internal/calgary/accidentReports/count", {
    params: { ...condition },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat", encode: false }),
  });
};

/**
 * 未稼働イベントに関連する事故報告を取得する
 * @param evCarId 車両ID
 * @param id 未稼働イベントのID
 * @returns 事故報告のリスト
 */
export const getAccidentReportsForNoopAPI = async (
  evCarId: number,
  eventId: number
): Promise<AxiosResponse<AccidentReport[]>> => {
  return httpClient.get(`core/internal/calgary/accidentReports/noop/${evCarId}`, {
    params: { eventId },
  });
};
